import type { ProductName } from '@atlassian/jira-shared-types/src/product-name.tsx';
import type { LicensedJiraProduct } from '@atlassian/jira-platform-react-hooks-use-is-admin-hub-ai-enabled/src/common/types.tsx';

export const PRODUCT_NAME: { [key: string]: ProductName } = {
	CORE: 'core',
	JIRA: 'jira',
	SERVICEDESK: 'serviceDesk',
	SOFTWARE: 'software',
	PRODUCT_DISCOVERY: 'product-discovery',
	CUSTOMER_SERVICE: 'customer-service',
};

export const ADMIN_HUB_AI_PRODUCT: { [key: string]: LicensedJiraProduct } = {
	JIRA_CORE: 'jira-core',
	JIRA_SERVICEDESK: 'jira-servicedesk',
	JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
	JIRA_SOFTWARE: 'jira-software',
	JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
};

/**
 * Takes in product name and returns it to a licensed product.
 * Necessary since the admin hub AI endpoint has a different naming convention
 */
export const getProductForAdminHubAi = (product: ProductName): LicensedJiraProduct => {
	switch (product) {
		case PRODUCT_NAME.CORE:
			return ADMIN_HUB_AI_PRODUCT.JIRA_CORE;

		case PRODUCT_NAME.SERVICEDESK:
			return ADMIN_HUB_AI_PRODUCT.JIRA_SERVICEDESK;

		case PRODUCT_NAME.CUSTOMER_SERVICE:
			return ADMIN_HUB_AI_PRODUCT.JIRA_CUSTOMER_SERVICE;

		case PRODUCT_NAME.PRODUCT_DISCOVERY:
			return ADMIN_HUB_AI_PRODUCT.JIRA_PRODUCT_DISCOVERY;

		case PRODUCT_NAME.SOFTWARE:
		case PRODUCT_NAME.JIRA:
		default:
			return ADMIN_HUB_AI_PRODUCT.JIRA_SOFTWARE;
	}
};
